import { SoftConfigThemeSchema } from '@tumelo/designsystem'
import { createGlobalStyle } from 'styled-components'

const defaultTheme = SoftConfigThemeSchema.parse()

export const PlannedMaintenanceStyles = createGlobalStyle`
  html,body {
    background-color: ${defaultTheme.colors.primary.dark};
    flex-grow:1;
    font-family: 'Montserrat';
  }

  h1 {
    color: ${defaultTheme.colors.white};
    text-align: center;
    padding-left: 3%;
    padding-right: 3%;
  }
`
